<template lang="pug">
el-dialog(
  v-draggable,
  :close-on-click-modal="false",
  append-to-body,
  :fullscreen="fullscreen",
  custom-class="approve",
  :title="flowTitle",
  :width="flowWidth",
  :visible.sync="flowDialog",
  :before-close="handleClose" )
  template(#title)
    .dialog-title
      .title {{ flowTitle }}
      span.flowStatus(:class="`type${status}`", v-if="approveType === 'edit'") {{ statusName(status) }}
      span(v-if="enablePrjSelector")
        span.selectorTitle 当前项目：
        prjIdSelect(:prjId="prjId", ref="prjIdSelect", :readonly="enableChangePrj", @changeProject="changeProject")
      .right(@dblclick.prevent.stop)
        el-button(size="small", type="primary", plain v-if="flowInstanceId" @click="showRecord") 审批记录
        el-button(size="small", type="primary", v-if="isAddUserSteps", :disabled="loading", v-loading="loading", @click="temporaryStorage") 暂存
        el-button(size="small", type="primary", v-if="isAddUserSteps", :disabled="loading", v-loading="loading", @click="submitProcess") 提交并发起流程
        el-button(size="small", type="primary", v-if="withdrawBoolean", @click="withdraw") 撤回
        el-button(size="small", type="primary", v-if="flowAgainBoolean", @click="relaunch") 重新发起
        el-button(size="small", type="primary", v-if="relaunchBoolean", :disabled="loading", v-loading="loading", @click="flowAgainSure") 流程再发起
  #summary(:style="{ height: this.flowHeight }")
    addApproval(:class="{ fullscreen: fullscreen }", :flowAgainAdd="flowAgainAdd", ref="addApproval", v-if="approveShow", :key="flowIndex" )
    flowDetail(:class="{ fullscreen: fullscreen }", ref="flowDetail", :viewMode="viewMode", v-else, @closeDialog="closeDialog", :key="flowIndex")
</template>

<script>
import flowDetail from "./flowDetail.vue";
import addApproval from "./addApproval.vue";
import { getFlowNodeHistory } from "../components/index";
import prjIdSelect from "../config/prjIdSelect.vue";
import { mapState } from "vuex";
import flowService from "@/CommonDP/service/flow-service";
import { getFormRequest } from "../config/flowFormRegister";
import { approveParams, setPrjID, getStatusName, setDefaultApproval, setDetailParams, initApproval,
  setBasicJson, setFlowNodeDtoList, setApprovalParams } from "../config";
export default {
  components: { flowDetail, addApproval, prjIdSelect },
  props: {
    dialogHeight: {
      type: String,
      default: ""
    },
    dialogWidth: {
      type: String,
      default: ""
    },
    // 审批模式：add 发起审批；edit：审批
    mode: {
      type: String,
      default: "add"
    },
    //  1：审批 2：查看 3：编辑（草稿） 4:发起审批
    view: {
      type: Number,
      default: 1
    },
    // 是否是项目内审批
    isProject: {
      type: Boolean,
      default: false
    },
    isDraft: Boolean
  },
  data() {
    return {
      flowDialog: false,
      loading: false,
      flowAgainAdd: false,
      relaunchBoolean: false,
      fullscreen: false, // 是否全屏
      queryMode: "",
      queryView: "",
      flowIndex: 0,
      draftId: "",
      draftFormData: {}
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      prjInfo: (state) => state.projectMg.prjObj,
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    approveParams() {
      return approveParams;
    },
    flowWidth() {
      return this.dialogWidth ? this.dialogWidth + "px" : "80%";
    },
    flowHeight() {
      return this.dialogHeight ? this.dialogHeight + "px" : "100%";
    },
    prjId() {
      return this.$route.query.prjId || approveParams.prjId || this.prjInfo.prjId || "";
    },
    // 审批模式：add 发起审批；edit：审批
    approveType() {
      return this.queryMode || this.mode ;
    },
    //  1：审批 2：查看 3：编辑（草稿）4:发起审批
    viewMode() {
      return this.queryView || this.view;
    },
    enableChangePrj() {
      return this.approveType !== "add";
    },
    // 流程名称
    flowName() {
      return approveParams.name;
    },
    // 弹框的流程标题
    flowTitle() {
      return this.approveType === "add" ? this.userInfo.name + " 发起" + (this.flowName || "流程") : "流程详情";
    },
    // 详情的status
    status() {
      return approveParams.detail.status;
    },
    // 申请人
    flowInstanceOwnerId() {
      return approveParams.detail.flowInstanceOwnerId || "";
    },
    // 流程处理人 节点用户
    flowNodeDtoList() {
      return approveParams.start.flowNodeDtoList;
    },
    // 是否有撤回按钮
    withdrawBoolean() {
      return this.status === 2 && this.approveType === "edit" && this.flowInstanceOwnerId === this.userInfo.userId;
    },
    // 是否有流程再发起按钮
    flowAgainBoolean() {
      return (this.status === 0 || this.status === 3) && this.approveType === "edit" && this.flowInstanceOwnerId === this.userInfo.userId && !this.relaunchBoolean;
    },
    // 是否有 提交并发起流程按钮
    isAddUserSteps() {
      return this.approveType === "add";
    },
    // 流程的流程id ,发起流程时没有
    flowInstanceId() {
      return approveParams.detail.flowInstanceId || "";
    },
    // 发起流程的参数
    addParams() {
      const { start: { json }, fileInfoList } = approveParams;
      const params = {
        ...approveParams.start,
        json: {
          fileInfoList,
          ...json
        },
        prjId: approveParams.formType === 1 ? this.prjId : "" // 项目内流程,项目id不可为空
      };
      return params;
    },
    relaunParams() {
      const { start: { json }, fileInfoList } = approveParams;
      return {
        ...approveParams.start,
        json: {
          fileInfoList,
          ...json
        },
        flowInstanceId: this.flowInstanceId,
        prjId: approveParams.formType === 1 ? this.prjId : "" // 项目内流程,项目id不可为空
      };
    },
    // 是否发起流程
    approveShow() {
      return this.approveType === "add" || this.flowAgainAdd === true || this.view === 3;
    },
    // 是否有 弹框title 是否有选择项目器, 项目菜单内打开都不会有——流程配置的项目选择器，在项目内不需要
    enablePrjSelector() {
      return approveParams.start.enablePrjSelector === 1 && !this.isProject;
    },
    flowKey() {
      return approveParams.flowKey;
    },
    // 是否调用标准的流程接口:std 是 ，customize 否
    isMethodInvokeMode() {
      return approveParams.methodInvokeMode === "std";
    },
    // 外部
    isOut() {
      return window.location.href.indexOf("jsName=BimEx") !== -1;
    }
  },
  mounted() {
    this.queryUrl();
  },
  methods: {

    /** 外部流程处理
     * url参数
     * @param queryMode add 发起审批；edit：审批
     * @param queryView 审批：1审批 2查看 3草稿编辑
     * @param currentVersionId 发起流程：版本id
     * @param flowKey 发起流程：流程id
     * @param businessId 审批流程：业务id
     */
    // 有url的时候处理数据
    async queryUrl() {
      const { queryMode, queryView, businessId, currentVersionId, flowKey } = this.$route.query;
      this.queryMode = queryMode || "";
      this.queryView = Number(queryView) || "";
      this.fullscreen = false;
      this.flowAgainAdd = false;
      // 草稿编辑
      if (queryMode === "add" && this.queryView === 3) {
        this.fullscreen = true;
        await initApproval();
        this.draftId = businessId;
        const data = await this.draftDetail(businessId);
        setApprovalParams({ ...data });
        this.flowDialog = true;
        await this.$nextTick();
        this.$refs.addApproval.flowDetail(businessId);
      } else if (queryMode === "add" && (currentVersionId || flowKey)) {
        // 发起流程
        this.fullscreen = true;
        await initApproval();
        // this.$refs.addApproval.loading = true;
        await this.queryFlowDef(currentVersionId, flowKey);
      } else if (queryMode === "edit" && businessId) {
        // 审批流程
        this.fullscreen = true;
        await initApproval();
        await this.queryFlowDetail(businessId);
      }
    },
    async queryFlowDef(currentVersionId, flowKey) {
      const res = await flowService.queryFlowDef(currentVersionId, "", flowKey);
      const row = { ...res.data };
      setDetailParams(row, this.enterpriseId);
      this.flowDialog = true;
      await this.$nextTick();
      if (this.isMethodInvokeMode) {
        this.$refs.addApproval.handleNextData(res.data || {});
      } else {
        this.$refs.addApproval.flowDetail();
      }
    },
    // url审批流程
    async queryFlowDetail(businessId) {
      const res = await flowService.queryFlowDetail(businessId);
      const row = { ...res.data };
      setDetailParams(row, this.enterpriseId);
      this.flowDialog = true;
      await this.$nextTick();
      this.$refs.flowDetail.flowDetail();
    },
    /**
     * 发起流程
     * @param row
     * @param row.name
     * @param row.currentVersionId
     * @param row.id
     * @param row.flowKey
     * @param row.flowDefinitionId
     * @param row.isDraftId // 草稿id,有该字段表示是草稿，
     * @param enterpriseId
     */
    async openAddDialog(row) {
      this.flowAgainAdd = false;
      initApproval();
      const { isDraftId = "" } = row;
      if (!isDraftId) { // 发起流程
        setDefaultApproval(row, this.enterpriseId);
      } else { // 草稿流程
        const data = await this.draftDetail(isDraftId);
        const params = { ...data, draftBusinessId: isDraftId };
        setDefaultApproval(params, this.enterpriseId);
      }
      this.flowDialog = true;
      await this.$nextTick();
      this.$refs.addApproval.flowDetail(isDraftId);
    },
    /**
     * 审批流程
     * @param row
     * @param row.businessName
     * @param row.currentVersionId
     * @param row.flowDefinitionId
     * @param row.businessType
     */
    async openEditDialog(row) {
      const { flowAgain } = row;
      this.flowAgainAdd = false;
      await initApproval();
      setDetailParams(row, this.enterpriseId);
      this.flowDialog = true;
      await this.$nextTick();
      await this.$refs.flowDetail.flowDetail();
      if (flowAgain) {
        await this.$nextTick();
        setTimeout(() => {
          this.relaunch();
        }, 1000);
      }
    },
    // 草稿详情
    async draftDetail(businessId) {
      const res = await flowService.getDraftFlowDetail(businessId);
      return res.data;
    },
    // 临时存储
    async temporaryStorage() {
      try {
        // if (this.loading) return;
        // this.loading = true;
        const json = await this.$refs.addApproval.getBasicData(false);
        if (json) {
          setBasicJson(json);
        }
        if (this.isMethodInvokeMode) {
          const res = await flowService.saveDraft({ ...this.addParams, businessId: this.draftId });
          this.draftId = res.data;
        } else {
          const url = getFormRequest().getRequestType(this.flowKey, "start", this.addParams);
          if (!url) {
            this.$message.warning(`该表单：${this.flowKey} 未配置对应的暂存接口`);
            this.flowAgainAdd = false;
            this.loading = false;
            return false;
          }
          await url;
        }
        this.$message.success("暂存成功");
        this.flowAgainAdd = false;
      } finally {
        this.loading = false;
      }
    },
    // 流程再发起
    async relaunch() {
      this.flowAgainAdd = true;
      await this.$nextTick();
      await this.$refs.addApproval.flowDetail();
      // this.$refs.addApproval.getFormData();
      this.relaunchBoolean = true;
    },
    async handleClose() {
      this.draftId = "";
      this.relaunchBoolean = false;
      this.flowIndex++;
      if (this.isOut) {
        await CefSharp.BindObjectAsync("cefSharpBrower");
        cefSharpBrower.closeWindow();
      } else if (this.fullscreen) {
        window.close();
      } else {
        this.flowDialog = false;
      }
    },
    // 审批状态
    statusName(status) {
      return getStatusName(Number(status));
    },
    // 提交并发起流程
    async submitProcess() {
      // 读取表单信息
      try {
        // if (this.loading) return;
        // this.loading = true;
        const json = await this.$refs.addApproval.startApproval();
        if (!json) {
          this.$message.warning("请填写完整表单");
          return;
        }
        setBasicJson(json);
        // 流程处理人 处理
        const nextStep = await this.dealNodeDtolist(json);
        if (!nextStep) {
          this.$message.warning("请处理流程处理人");
          return;
        }
        if (this.isMethodInvokeMode) {
          await flowService.addFlow(this.addParams);
        } else {
          const url = getFormRequest().getRequestType(this.flowKey, "start", this.addParams);
          if (!url) {
            this.$message.warning(`该表单：${this.flowKey} 未配置对应的提交并发起流程接口`);
            this.flowAgainAdd = false;
            // this.loading = false;
            return false;
          }
          await url;
        }
        this.$message.success("请求成功");
        this.flowAgainAdd = false;
        this.closeDialog();
      } finally {
        this.loading = false;
      }
    },
    // 发起流程 获取流程处理人节点用户:申请人自选
    async dealNodeDtolist(json) {
      const flowNodeDtoListBoolean = this.flowNodeDtoList.length;
      if (!flowNodeDtoListBoolean) {
        const flowNodeDtoList = await this.$refs.addApproval.queryFlowNodeList(json);
        // 有节点为申请人自选 没有勾选 审批时才决定处理人 按钮
        if (flowNodeDtoList.some((e) => e.assigneeSelectionStrategy === "2" && e.runtimeSelectUsers === 0)) {
          this.$message.warning("有节点为申请人自选，请选择节点的审批人");
          return false;
        }
        // 下一个节点为申请人自选
        const nextNode = flowNodeDtoList[1];
        if (nextNode.assigneeSelectionStrategy === "2") {
          this.$message.warning("下个节点为申请人自选，请选择下个节点的审批人");
          return false;
        }
        setFlowNodeDtoList(flowNodeDtoList, "add");
        return true;
      } else {
        const nodes = this.$refs.addApproval.nodes;
        const flowNodeDtoList = this.flowNodeDtoList;
        const index = flowNodeDtoList.findIndex((e, index) => (e.userDtoList.length === 0 || e.userDtoList.filter(i => i.type === 0).length === 0) && index > 0);
        if (index > -1) {
          const { data } = nodes[index];
          if (data.assigneeSelectionStrategy === "2" && data.runtimeSelectUsers === 0) {
            this.$message.warning("有节点为申请人自选，请选择节点的审批人");
            return false;
          }
        }
        // 下一个节点为申请人自选
        const nextNode = flowNodeDtoList[1];
        if (nextNode.userDtoList.length === 0 && nextNode.assigneeSelectionStrategy === "2") {
          this.$message.warning("下个节点为申请人自选，请选择下个节点的审批人");
          return false;
        }
        return true;
      }
    },
    // 撤回
    withdraw() {
      this.$confirm(`您确定撤回当前流程吗?`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const params = { flowInstanceId: this.flowInstanceId };
          await flowService.withdraw(params);
          this.$success("流程撤回成功");
          this.closeDialog();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 流程再发起
    async flowAgainSure() {
      try {
        if (this.loading) return;
        this.loading = true;
        const json = await this.$refs.addApproval.startApproval();
        if (!json) return;
        setBasicJson(json);
        // 申请人自选
        const Boolean = await this.dealNodeDtolist(json);
        if (!Boolean) {
          return;
        }
        if (this.isMethodInvokeMode) {
          await flowService.restart(this.relaunParams);
        } else {
          const url = getFormRequest().getRequestType(this.flowKey, "restart", this.addParams);
          if (!url) {
            this.$message.warning(`该表单：${this.flowKey} 未配置对应的流程再发起接口`);
            this.flowAgainAdd = false;
            this.loading = false;
            return false;
          }
          await url;
        }
        this.$message.success("请求成功");
        this.closeDialog();
      } finally {
        this.loading = false;
      }
    },
    // 查看流程记录
    showRecord() {
      const props = { flowInstanceId: this.flowInstanceId };
      getFlowNodeHistory(props);
    },
    // 切换项目
    async changeProject(id) {
      await this.$nextTick();
      setPrjID(id);
    },
    closeDialog() {
      this.$emit("updateTable");
      this.handleClose();
    }
  }
};
</script>
<style lang="scss" scoped>
#summary {
  width: 100%;
  height: 100%;
  overflow: hidden;

  .fullscreen {
    height: 100%;
  }
}
</style>
<style lang="scss">
.approve {
  .el-dialog__body {
    padding: 10px 5px !important;
    border-bottom: 0 !important;
  }
}

.dialog-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-right: 50px;

  .title {
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
  }

  .right {
    margin-left: auto;
    display: flex;
    flex-direction: row;
    align-items: center;

    .el-button {
      margin-left: 5px;
    }
  }
}

.flowStatus {
  margin-left: 10px;
  border-radius: 6px;
  text-align: center;
  padding: 4px 6px;
}

.type1,
.type4 {
  background: rgba(0, 182, 50, 0.24);
  color: #00b632;
}

.type2 {
  background: rgba(243, 124, 38, 0.15);
  color: #f37c26;
}

.type3 {
  background: #70737e;
  color: #fff;
}

.type5 {
  background: rgba(243, 124, 38, 0.15);
  color: #f37c26;
}

.type0 {
  background: rgba(236, 54, 42, 0.15);
  color: #ec3226;
}

.type9 {
  border-color: #70737e;
  border: solid 1px;
  padding-top: 2px;
  padding-bottom: 2px;
}

.selectorTitle {
  /* font-weight: 400; */
  font-size: 16px;
  line-height: 22px;
  margin-left: 20px;
  margin-right: 10px;
}
</style>
